const statusEnvelope = {
    Created: 1,
    Sent: 2,
    Completed: 3,
    Canceled: 4,
    Declined: 5,
    NotIdentified: 6
};

export default statusEnvelope